import React from 'react'
import PropTypes from 'prop-types'
import { Button, EmptyState, Text } from '@plurall/elo-beta'
import styles from './EmptyStateResponsible.module.scss'

const EmptyStateResponsible = ({ navigateToAccountApproval }) => {
  return (
    <div className={styles['empty-state-card']}>
      <EmptyState
        button={
          <Button
            dataTestId='empty-state-add-responsible-button'
            secondary
            className={styles['table-responsible']}
            onClick={navigateToAccountApproval}
          >
            Vincular responsável
          </Button>
        }
        icon='Link'
        title='Nenhum responsável vinculado à sua conta'
      >
        <Text size='t3' dimmed alignment='center'>
          Para vincular sua conta a um responsável, clique em "Vincular responsável".
        </Text>
      </EmptyState>
    </div>
  )
}
EmptyStateResponsible.propTypes = {
  navigateToAccountApproval: PropTypes.func,
}

export default EmptyStateResponsible
